// extracted by mini-css-extract-plugin
export default {"ArrowHeight":"30px","container":"G2b2fd6","tooltip__content":"Gefa68a"};